import React from 'react';
import styled from 'styled-components';
import { ReactComponent as ArrowUp } from '../../assets/icons/arrow-up.svg';
import { DEFAULT_ANIMATION_SPEED_MS } from '../config';

export enum ArrowDirection {
	Up = 'Up',
	Down = 'Down',
	Left = 'Left',
	Right = 'Right',
}

export interface ArrowIconProps extends React.SVGAttributes<SVGElement> {
	direction?: ArrowDirection;
	className?: string;
}

const getDirection = (direction: ArrowDirection) => {
	switch (direction) {
		case ArrowDirection.Up:
		default:
			return 0;
		case ArrowDirection.Right:
			return 90;
		case ArrowDirection.Down:
			return 180;
		case ArrowDirection.Left:
			return 270;
	}
};

const StyledArrowUp = styled(ArrowUp)`
	transition: transform ${DEFAULT_ANIMATION_SPEED_MS}s;
	transform: rotate(${props => getDirection(props.direction as ArrowDirection)}deg);
` as typeof ArrowUp;

const ArrowIcon: React.FC<ArrowIconProps> = ({ className, ...props }) => {
	return <StyledArrowUp {...props} className={className} />;
};

export default ArrowIcon;
